import { Value } from "react-rainbow-components/components/DatePicker";
import { AwarenessCampaignData } from "../../../models/AwarenessCampaign";

export const filterCampaignsByDateRange = (
    campaigns: AwarenessCampaignData[],
    dateRange: { date: Value | undefined }
): AwarenessCampaignData[] => {
    if (!dateRange.date) return campaigns;
    
    return campaigns.filter(campaign => {
        if (!campaign.deadline) return false;
        
        const deadlineDate = new Date(campaign.deadline);
        const { date } = dateRange;
        
        if (!Array.isArray(date) || date.length !== 2) {
            return true;
        }
        
        const [startDate, endDate] = date;

        if (!startDate || !endDate) {
            return true;
        }

        const start = new Date(startDate);
        const end = new Date(endDate);
        end.setHours(23, 59, 59, 999); // Include full end day
        
        return deadlineDate >= start && deadlineDate <= end;
    });
};